import Client from 'modules/Client'

export default {
  create (id, data) {
    return Client.post(`api/aluno/curso/${id}/opiniao`, { data })
  }
}
